import React from 'react'

export default ({className, value, ariaDisabled, ...props}) => {
    return (
        <div className="form-group">
            <input {...props}
                   type="submit"
                   value={value}
                   aria-disabled={ariaDisabled}
                   className={`${className} form-control btn btn-block btn-primary`}/>
        </div>
    )
}
